module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "الإهداء"
    }
  }, [_c('h1', {
    staticStyle: {
      "font-family": "Dubai"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الإهداء")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "1.47917in",
      "height": "1.88542in"
    },
    attrs: {
      "alt": "",
      "src": "media/file1.png"
    }
  })]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("إلى ابنتيَّ المحبوبتين: (صوفيا ماريا لورا) و(إيفا ميا أنجلينا)، هذا الكتابُ مُخصَّصٌ لكما ولجميع النِّساء اللواتي سيأتِينَ مِن بعدكما.")])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("في أثناء رحلتكما في هذه الحياة، وعند مواجهة تقلُّباتِها، آملُ أن يكونَ هذا الكتابُ بمنزلةِ ضوءٍ إرشاديٍّ، وتذكيرٍ بقوَّتكما وجمالكما وقيمتِكما، وكلَّما شعرتُما بالضّياع أو عدمِ اليقين، تذكَّرا هذه الصَّفحاتِ بالقوَّة الكامنةِ في داخلكما، وآملُ أنْ تُلهمكما لاحتضان شغفكما، واتّباعِ أحلامكما لكي لا تَقْبَلا أبدًا بأيِّ شيءٍ أقلَّ ممَّا تستحقَّانه.")])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("إلى كلِّ النِّساء اللّواتي كان لَهُنَّ تأثيرٌ في حياتي، أشكُرُكُنَّ، سواءً علَّمَتني إحداكُنَّ دروسًا قيِّمةً، أو أضاءت أخرى يوميَ بلُطفها، فقد تَركْتُنَّ بصمةً لا تُمحى في قلبي، أحملُ دائمًا الحكمةَ الَّتي تلقَّيتُها مِنكُنَّ، وأَثَرَ كلِّ لقاءٍ معكُنَّ، ومن دواعي سروريَ البالغِ أنْ أُهدي لكُنَّ هذا الكتابَ، آملةً أنْ ترفعَ الكلماتُ الموجودةُ في هذه الصفحاتِ من معنويّاتكُنَّ وتشجِّعكُنَّ وتُحفِّزكُنَّ، بينما تستمرُّ كلٌّ منكُنَّ في تركِ بصمتِها في هذا العالمِ، وآملُ أنْ تتذَكَّرْنَ دائمًا أنَّكُنَّ محبوباتٌ، ومقدَّراتٌ، وعزيزاتٌ بمقدارٍ لا يُضاهَى.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4eff773e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch003.vue
// module id = 66
// module chunks = 0